import {ManagedMethodKind} from '@entities/paymentMethod';
import {ManagedMethodsTable} from './ManagedMethodsTable';

export const PayoutMethodsTab = () => (
  <ManagedMethodsTable kind={ManagedMethodKind.payout} />
);
